export default __webpack_public_path__ + "static/media/34.5695d763.png";